{
  "SYSTEM_STATUS_MESSAGE": {
    "OK": "Alles\n ist ok",
    "INFO": "Alles\n ist ok",
    "FAULT": "",
    "WARNING": ""
  }
}
